module.exports = __webpack_public_path__ + "static/img/type2.e9c7d4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type2.png
// module id = Bh6S
// module chunks = 1